export const PERMISSION_DENIED = "permission_denied";



// WEBPACK FOOTER //
// ./src/constants/error_types.js